import React, { useRef } from 'react';
import { message } from 'antd';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import AdvanceNotice from 'components/Calendar/AdvanceNotice';
import { ReminderSettings } from 'types/calendarSetting';
import { useSwitchedProvider } from '../../SwitchedProviderContext';
import commonS from '../../s.module.less';

interface Props {
    initValue?: ReminderSettings | null;
}

const MinimumTimeCard: React.FC<Props> = ({ initValue }) => {
    const { scheduleToken, onRefresh } = useSwitchedProvider();
    const advanceNoticeRef = useRef<{ onUpdate: () => Promise<void> }>(null);

    const handleSave = async () => {
        try {
            await advanceNoticeRef.current?.onUpdate();
            message.success('Minimum time in advance saved');
            onRefresh?.();
        } catch (error) {
            console.error('Form save failed:', error);
        }
    };

    const renderEditing = () => (
        <div className={commonS.displayItem}>
            <div className={commonS.label}>Advance notice</div>
            <AdvanceNotice ref={advanceNoticeRef} value={initValue} scheduleToken={scheduleToken} />
        </div>
    );

    const renderReview = () => {
        const { minAdvanceBookingHours } = initValue || {};
        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Advance notice</div>
                <div className={commonS.value}>
                    {minAdvanceBookingHours
                        ? `Patients must book at least ${minAdvanceBookingHours} hours in advance`
                        : 'No restriction'}
                </div>
            </div>
        );
    };

    return (
        <FormCard type="review" title="Minimum time in advance" hasContent onSave={handleSave}>
            {(isEditing) => (isEditing ? renderEditing() : renderReview())}
        </FormCard>
    );
};

export default MinimumTimeCard;
